import { ORG_PERMISSIONS } from 'utils/permissions';

// Maximum lengths for input fields
export const MAX_EMAIL_LENGTH = 254;
export const MAX_FULL_NAME_LENGTH = 200;
export const MAX_ROLE_NAME_LENGTH = 200;
export const MAX_TEAM_NAME_LENGTH = 200;

// Tooltip texts for RBAC permission enforcement
export const CANNOT_MANAGE_MEMBERS =
  'To manage a member’s roles on a project, you must also be a member of that project.';
export const CANNOT_REMOVE_MEMBERS = 'To remove members from a project, you must also be a member.';
export const CANNOT_ADD_MEMBERS = 'To add members to a project, you must also be a member.';

export const ROLE_BREADCRUMBS = [
  {
    key: 'Roles',
    content: 'Roles',
    link: true,
    href: '/roles',
  },
];

export const ORG_PERMISSION_NAMES_BY_KEY = {
  [ORG_PERMISSIONS.CreateProjects]: 'Create projects',
  [ORG_PERMISSIONS.ManageBilling]: 'Manage billing',
  [ORG_PERMISSIONS.ManageMembers]: 'Manage members',
  [ORG_PERMISSIONS.ManageRoles]: 'Manage roles',
};

export const ORG_PERMISSION_ORDERING = {
  [ORG_PERMISSIONS.CreateProjects]: 0,
  [ORG_PERMISSIONS.ManageBilling]: 1,
  [ORG_PERMISSIONS.ManageMembers]: 2,
  [ORG_PERMISSIONS.ManageRoles]: 3,
};
